import { CountryEntity } from 'api/types/entity';
import { Maybe } from 'types/maybe';

export const parseCitizenshipsValue = (
  citizenships: Maybe<CountryEntity>[] | undefined
): Maybe<CountryEntity>[] => (citizenships?.length ? citizenships : [null]);
